import { useState } from 'react';
import { useTranslation } from '../../../components/Translation';
import ProjectModal from './ProjectModal';

export type ProjectCardProps = {
  titleKey: string;
  titleText: string;
  descriptionKey: string;
  descriptionText: string;
  imageSrc: string;
  showButton?: boolean;
  category?: string;
  members?: string[];
  gallery?: { type: "image" | "video"; src: string }[];
  projectType: "tesis" | "investigacion" | "interes" | "nacional" | "internacional" | "academia";

};


export default function ProjectCard(props: ProjectCardProps) {
  const { titleKey, titleText, descriptionKey, descriptionText, imageSrc, showButton, category, members, projectType } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);


  return (
    <>
      <div className="rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-row h-80 border border-white/60"
        style={{
          background: "rgba(255,255,255,0.7)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          boxShadow: "0 4px 24px rgba(13,31,53,0.08), inset 0 1px 0 rgba(255,255,255,0.8)"
        }}
      >
        {/* Imagen — 40% ancho, altura completa */}
        <div className="w-2/5 flex-shrink-0 overflow-hidden relative">
          <img
            src={imageSrc}
            alt={titleText}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-r from-transparent to-white" />
          {/* Badge tipo de proyecto */}
          <span className="absolute top-3 left-3 text-micro font-bold px-3 py-1 rounded-full bg-dorado-uady/20 text-dorado-uady backdrop-blur-sm border border-dorado-uady/30">
            {t(`lineas.badge_${projectType}`)}
          </span>
        </div>

        {/* Contenido — 60% ancho con scroll si es necesario */}
        <div className="flex-1 p-5 flex flex-col overflow-hidden">
          {category && (
            <span className="text-micro font-bold uppercase text-dorado-uady tracking-widest mb-2 block">
              {category}
            </span>
          )}
          <h3 className="text-base font-bold text-azul-uady mb-2 leading-snug">
            {t(`lineas.${titleKey}`) !== `lineas.${titleKey}` ? t(`lineas.${titleKey}`) : titleText}
          </h3>

          <div className="flex-1 overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-200 scrollbar-track-transparent">
            <p className="text-mini text-gray-600 leading-relaxed text-justify">
              {(t(`lineas.${descriptionKey}`) !== `lineas.${descriptionKey}`
                ? t(`lineas.${descriptionKey}`)
                : descriptionText
              ).split('<br>').map((p: string, i: number) => (
                <span key={i}>{p}{i > 0 && <br />}</span>
              ))}
            </p>
          </div>

          <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100 flex-shrink-0">
            <div className="flex flex-wrap gap-1">
              {members && members.slice(0, 2).map((m, i) => (
                <span key={i} className="text-micro bg-azul-uady/10 text-azul-uady font-semibold px-2 py-0.5 rounded-full whitespace-nowrap">
                  {m}
                </span>
              ))}
              {members && members.length > 2 && (
                <span className="text-micro bg-gray-100 text-gray-500 font-semibold px-2 py-0.5 rounded-full">
                  +{members.length - 2}
                </span>
              )}
            </div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="text-mini text-dorado-uady font-semibold hover:underline whitespace-nowrap"
            >
              Ver detalles →
            </button>
          </div>

          {showButton && (
            <a
              href="#"
              title="COMING SOON"
              className="mt-2 text-center text-micro text-white bg-azul-uady px-4 py-2 rounded hover:bg-dorado-uady transition-colors flex-shrink-0"
            >
              {t('lineas.granja_acceso')}
            </a>
          )}
        </div>
      </div>

      {isModalOpen && (
        <ProjectModal {...props} onClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
}